/**
 * 囃子（BGM）確認ポップアップの判定（ユーザー指示: 初回確認、最終操作から約30分で再確認）。
 * ブラウザの自動再生制限を解くための明示的な操作としても使う。
 */

/** 最終操作からこの時間が経ったら、囃子の確認を再度出す。 */
export const MUSIC_CONSENT_IDLE_MS = 30 * 60 * 1000;

/**
 * 囃子確認を出すべきか。
 * - まだ一度も答えていない → 出す
 * - 答えたあとも、最終操作から `MUSIC_CONSENT_IDLE_MS` 以上経過 → 出す
 */
export function shouldPromptMusicConsent(
  decidedAt: number | null,
  lastActivityAt: number,
  now: number,
): boolean {
  if (decidedAt === null) {
    return true;
  }
  return now - lastActivityAt >= MUSIC_CONSENT_IDLE_MS;
}
